const VotingResults = ({ votingResults }) => {

    if (!votingResults) return;

    return (

        <div id="voting-results-participation-app">
            <div className="voting-results-sec">
                {votingResults?.map(({ voting_results, voting_question }, index) => (
                    <div key={index} className="voting-results">
                        <h3 dangerouslySetInnerHTML={{ __html: voting_question }} />
                        <div className="voting-results__container">
                            {voting_results && Object.entries(voting_results).map(([label, data], resultIndex) => (
                                <div key={resultIndex} className="voting-results__item">
                                    <span className="voting-results__percentage" style={{ color: data?.color || '#0550E6' }}>{data.percentage.toFixed(0)}%</span>
                                    <div class="voting-results__bar-wrapper">
                                        <div
                                            className="voting-results__bar-container"
                                            style={{
                                                height: `${data.percentage * 5}px`,
                                                backgroundColor: data?.color || '#0550E6'
                                            }}
                                        >
                                        </div>
                                    </div>
                                    {!data.image && <h5 className="voting-results__label" style={{ color: data?.color || '#0550E6' }}>{label}</h5>}
                                    {data.image && <img src={data.image} alt={label} />}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>

    )
}
export default VotingResults